import React from 'react';
import IconDefault from '../../icons/IconDefault';

export default class StepHorizontalField extends React.Component {
    static defaultProps = {
        inputTips: []
    }

    renderDefButton() {
        let renderButton = () => (
            <div style={{margin: '0 5px'}} onClick={this.props.onDefaultButtonClick}>
                <IconDefault/>
            </div>
        )

        let renderEmpty = () => (
            <span>
                &nbsp;
            </span>
        )

        return (
            <div className="heating-horizontal-field-default">
                {this.props.defaultButtonVisible ? renderButton() : renderEmpty()}
            </div>
        )
    }

    renderMetaData() {
        if (this.props.unit && this.props.defaultButtonVisible) {
            return (
                <React.Fragment>
                    <div className="field-column3" style={{width: '10%', textAlign: 'center'}}>
                        {<span className="unit">{this.props.unit}</span>}
                    </div>
                    <div className="field-column3" style={{width: '10%', textAlign: 'center'}}>
                        {this.renderDefButton()}
                    </div>
                </React.Fragment>
            )
        }
        if (this.props.unit) {
            return (
                <div className="field-column3" style={{width: '10%', textAlign: 'center'}}>
                    {<span className="unit">{this.props.unit}</span>}
                </div>
            )
        }
        if (this.props.defaultButtonVisible) {
            return (
                <div className="field-column3" style={{width: '10%', textAlign: 'center'}}>
                    {this.renderDefButton()}
                </div>
            )
        }
    }

    render() {
        if (this.props.visible === false) {
            return <React.Fragment></React.Fragment>
        }

        let classNames = 'configuration-field-container'
        if (this.props.className) {
            classNames += ' ' + this.props.className
        }
        if (this.props.readonly) {
            classNames += ' ' + '--readonly'
        }

        return (
            <div className={classNames}>
                <div className="configuration-field-row" style={{display: 'flex'}}>
                    <div className="field-column1" style={{width: '40%'}}>
                        {this.props.label}
                    </div>
                    <div className="field-column2" style={{
                        display: 'flex',
                        width: (this.props.unit && this.props.defaultButtonVisible) ? '30%' : '40%'
                    }}>
                        {this.props.children}
                    </div>
                    {this.renderMetaData()}
                </div>
                <div className="configuration-field-row">
                    <div className="field-column1" style={{width: '40%'}}/>
                    <div className="field-column23" style={{width: '40%'}}>
                        {this.renderTips()}
                    </div>
                </div>
                {this.props.renderAdditionalFilters && <div className="configuration-field-row">
                    <div className="field-column1" style={{width: '40%'}}/>
                    <div className="field-column23" style={{width: '60%'}}>
                        {this.props.renderAdditionalFilters()}
                    </div>
                </div>}
            </div>
        )
    }

    renderTips() {
        if (this.props.inputTips.length === 0) {
            return <React.Fragment></React.Fragment>;
        }

        return (
            <div className="field-tips">
                {this.props.inputTips.map((tip, idx) => (
                    <div key={idx}>{tip}</div>
                ))}
            </div>
        )
    }
}